import React, { Component } from "react";

class RadioBoxSVG extends React.Component {
  render() {
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 12 12"
      >
        <circle className="svg" cx="6" cy="6" r="4" />
      </svg>
    );
  }
}

export default RadioBoxSVG;



// WEBPACK FOOTER //
// ./src/svg/RadioBoxSVG.jsx